var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-4.000000, -4.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.69207527,4.29031422 L12,10.598 L18.3079247,4.29031422 C18.6652345,3.93300441 19.227471,3.90551904 19.616308,4.20785811 L19.7096858,4.29031422 C20.0967714,4.67739984 20.0967714,5.30498964 19.7096858,5.69207527 L19.7096858,5.69207527 L13.402,12 L19.7096858,18.3079247 C20.0967714,18.6950104 20.0967714,19.3226002 19.7096858,19.7096858 C19.3226002,20.0967714 18.6950104,20.0967714 18.3079247,19.7096858 L12,13.402 L5.69207527,19.7096858 C5.33476546,20.0669956 4.77252902,20.094481 4.38369204,19.7921419 L4.29031422,19.7096858 C3.90322859,19.3226002 3.90322859,18.6950104 4.29031422,18.3079247 L4.29031422,18.3079247 L10.598,12 L4.29031422,5.69207527 C3.90322859,5.30498964 3.90322859,4.67739984 4.29031422,4.29031422 C4.67739984,3.90322859 5.30498964,3.90322859 5.69207527,4.29031422 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.1a41149080b1918644264b8c9b3441af.svg";
export { ForwardRef as ReactComponent };